import { ObjectDetailsContentLayout } from 'framework/ViewTypes/contentLayout';
import { ObjectDetailsSections } from 'framework/ViewTypes/embeddable';
import { POSITION_SLOT_LIFECYCLE, POSITION_SLOT_LIFECYCLE_LABELS } from '../../constants';
import type { PreviewPositionSlotListItem } from '../../types';
import { getPositionSlotHeaderActions } from '../header/headerActions';
import type { PositionSlotHeaderCallbacks, PositionSlotHeaderPermissions } from '../header/headerActions';
import PositionSlotProcessTabs from '../tabs/PositionSlotProcessTabs';
import PositionSlotDetailsCard from './PositionSlotDetailsCard';
import PositionSlotSecondaryCompetencies from './PositionSlotSecondaryCompetencies';
import { buildPositionSlotTitle } from '../../shared/utils/positionSlotTitle';

type PositionSlotDetailsContentProps = {
  positionSlot?: PreviewPositionSlotListItem;
  loading?: boolean;
  error?: Error | null;
  retry?: () => void | Promise<unknown>;
  callbacks: PositionSlotHeaderCallbacks;
  permissions: PositionSlotHeaderPermissions;
};

const PositionSlotDetailsContent = ({
  positionSlot,
  loading,
  error,
  retry,
  callbacks,
  permissions,
}: PositionSlotDetailsContentProps) => (
  <ObjectDetailsContentLayout
    data={positionSlot}
    loading={loading}
    error={error}
    retry={retry}
    notFoundMessage="Position not found."
    renderContent={loadedPositionSlot => ({
      header: {
        title: buildPositionSlotTitle(loadedPositionSlot),
        badges: [
          {
            id: 'lifecycle',
            label: POSITION_SLOT_LIFECYCLE_LABELS[loadedPositionSlot.lifecycle] || loadedPositionSlot.lifecycle,
            color: loadedPositionSlot.lifecycle === POSITION_SLOT_LIFECYCLE.RETIRED ? 'default' : 'info',
          },
        ],
        actions: getPositionSlotHeaderActions(loadedPositionSlot, callbacks, permissions),
      },
      leftSide: (
        <ObjectDetailsSections
          sections={[
            {
              title: 'Position details',
              content: <PositionSlotDetailsCard positionSlot={loadedPositionSlot} />,
            },
            ...(loadedPositionSlot.secondaryCompetencyItems?.length
              ? [
                  {
                    title: 'Secondary competencies',
                    content: <PositionSlotSecondaryCompetencies positionSlot={loadedPositionSlot} />,
                  },
                ]
              : []),
          ]}
        />
      ),
      rightSide: <PositionSlotProcessTabs canCreateTimelineEntry={permissions.canCreateTimelineEntry} />,
    })}
  />
);

export default PositionSlotDetailsContent;
